import generateId from 'lib/generateId';
import stringHash from 'string-hash';

export default function() {
  let id = generateId();

  while (stringHash(id) % 100 === 0) {
    id = generateId();
  }

  return id;
}
